module.exports = __webpack_public_path__ + "img/btn_back.3da29616.png";